import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@material-ui/core/InputAdornment'
import TextField from '@material-ui/core/TextField'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import styled from 'styled-components'
import { TableViewStoreContext } from '../container/StandardTableView'

export interface ITableSearch {
  height: number
  width: number
}

const SearchBox = styled(TextField)(() => ({
  '& fieldset': {
    borderRadius: '15px'
  }
}))

export const StyledTextSearchComponent = styled(
  ({ height, width, handleChange, value, ...rest }) => (
    <SearchBox
      {...rest}
      variant='outlined'
      size='small'
      id='input-with-icon-textfield'
      placeholder={''}
      onChange={handleChange}
      value={value}
      InputProps={{
        inputProps: { style: { textAlign: 'left', padding: 8 } },
        style: {},
        endAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        )
      }}
    />
  )
)(props => ({
  '&': {
    height: props.height + 'px',
    width: props.width + 'px',
    input: {
      font: 'var(--typography-body1)'
    },
    '> div': {}
  }
}))

export const TableSearch: React.SFC<ITableSearch> = ({ height, width }) => {
  return useObserver(function useHook() {
    const { handleSearchTextChange, searchText } = React.useContext(
      TableViewStoreContext
    ) as any
    return (
      <StyledTextSearchComponent
        height={height}
        width={width}
        value={searchText}
        handleChange={handleSearchTextChange}
      />
    )
  })
}
